import { Action } from 'common/interfaces/root';
import { recommendedAsinsActionTypes as TYPES } from '../actions';

const initialState: AffiliateGainzModule.RecommendedAsinsModule.PlacementsState = {
  loading: false,
  data: null,
  error: null,
};

export default (
  state: AffiliateGainzModule.RecommendedAsinsModule.PlacementsState = initialState,
  { type, payload }: Action
): AffiliateGainzModule.RecommendedAsinsModule.PlacementsState => {
  switch (type) {
    case TYPES.PLACEMENTS.GET_PLACEMENTS:
      return { ...state, loading: true };
    case TYPES.PLACEMENTS.GET_PLACEMENTS_SUCCESS:
      return { ...state, loading: false, data: payload };
    case TYPES.PLACEMENTS.GET_PLACEMENTS_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
